import React, { useCallback } from 'react';
import { LocalMessage } from 'stream-chat';

export interface PinnedMessageBannerProps {
  pinnedMessage: LocalMessage;
  previewText: string;
  canUnpin: boolean;
  onSelectPinnedMessage: () => void;
  onRequestUnpin: () => void;
}

const PinnedMessageBanner: React.FC<PinnedMessageBannerProps> = ({
  pinnedMessage,
  previewText,
  canUnpin,
  onSelectPinnedMessage,
  onRequestUnpin,
}) => {
  const handleContextMenu = useCallback(
    (event: React.MouseEvent) => {
      if (!canUnpin) {
        return;
      }

      event.preventDefault();
      onRequestUnpin();
    },
    [canUnpin, onRequestUnpin],
  );

  const handleUnpinClick = useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation();
      onRequestUnpin();
    },
    [onRequestUnpin],
  );

  return (
    <div
      key={pinnedMessage.id}
      className="pinned-message-banner-enter pointer-events-auto flex items-stretch gap-2 rounded-[20px] bg-brand-bg-4 shadow-md px-3 py-2.5"
      role="status"
      aria-live="polite"
    >
      <button
        type="button"
        className="min-w-0 flex-1 flex items-stretch gap-3 text-left transition-colors hover:opacity-90"
        onClick={onSelectPinnedMessage}
        onContextMenu={handleContextMenu}
      >
        <div
          className="w-1 shrink-0 self-stretch rounded-full bg-brand-color-1 mt-1 mb-1"
          aria-hidden
        />

        <div className="min-w-0 flex-1">
          <div className="text-sm font-semibold text-brand-color-1 truncate">
            Pinned Message
          </div>
          <div className="text-sm text-brand-color-2 truncate">{previewText}</div>
        </div>
      </button>

      {canUnpin && (
        <button
          type="button"
          className="shrink-0 self-start p-1 rounded-full text-brand-color-2 hover:text-brand-color-1 hover:bg-brand-bg-3/80 transition-colors"
          onClick={handleUnpinClick}
          aria-label="Unpin message"
        >
          <span className="material-icons text-[18px] leading-none">close</span>
        </button>
      )}
    </div>
  );
};

export default PinnedMessageBanner;
